import { langRouteI18n } from '@bcf-v2/routes/common/app/i18n/lang-route-i18n';
import { virtualSportsRouteI18n } from '../i18n/virtual-sports-route-i18n';

export function virtualSportsRoutePath(): string {
  return `/${langRouteI18n()}/${virtualSportsRouteI18n()}`;
}
